(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.nbNO = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Ingen data er funnet'
      },
      combobox: {
        placeholder: 'Velg',
        searchPlaceholder: 'Søk'
      },
      datepicker: {
        apply: 'Bruk',
        clearSelection: 'Tøm',
        pickADays: 'Velg dager',
        prevYear: 'Forrige år',
        nextYear: 'Neste år',
        prevMonth: 'Forrige måned',
        nextMonth: 'Neste måned',
        year: '',
        month1: 'Januar',
        month2: 'Februar',
        month3: 'Mars',
        month4: 'April',
        month5: 'Mai',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'August',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'Desember',
        weeks: {
          sun: 'Søn',
          mon: 'Man',
          tue: 'Tir',
          wed: 'Ons',
          thu: 'Tor',
          fri: 'Fre',
          sat: 'Lør'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Mai',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Des'
        },
        pickADay: 'Velg en dag'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Ingen data er funnet'
      },
      filepicker: {
        browse: 'Bla igjennom',
        select: 'Velg en fil'
      },
      filter: {
        apply: 'Bruk',
        cancel: 'Avbryt',
        filterButton: 'Filter',
        reset: 'Tilbakestill filtre',
        resetDefault: 'Tilbakestill til standard'
      },
      search: {
        noDataMessage: 'Ingen data er funnet'
      },
      'multi-search': {
        'separator-and': 'OG',
        'search-button': 'Søk',
        'search-placeholder': 'Søk etter navn'
      },
      select: {
        all: 'Alle',
        clearSelection: 'Fjern markering',
        noMatch: 'Ingen data er funnet',
        noData: 'Ingen data',
        placeholder: 'Velg',
        item: 'element(er)',
        selected: 'valgt',
        found: 'funnet'
      },
      upload: {
        browseButton: 'Bla igjennom',
        text: 'Dra og slipp filer for å laste opp eller klikk «Bla gjennom»',
        tip: 'Du kan laste opp 10 filer som er opptil 25 MB hver'
      },
      table: {
        emptyText: 'Ingen data'
      },
      tree: {
        emptyText: 'Ingen data'
      }
    }
  };
  _exports.default = _default;
});